import { Component, ChangeDetectorRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { TFMService } from 'app/mock-api/tfm.service';
import { FuseCardComponent } from '@fuse/components/card';
import { NgFor, NgStyle, CommonModule } from '@angular/common';
import { CountersType01Component } from "../../counter/counters-type01/counters-type01.component";
import { ScrollerSectionType01Component } from "../../scroller-section/scroller_section-type01/scroller_section-type01.component";
import { BannerSectionType01Component } from "../../banner-section/banner_section-type01/banner_section-type01.component";
import { ChangeGameType01Component } from '../../change-game/change-game-type01/change-game-type01.component';

@Component({
  selector: 'app-corporate-travel-type02',
  standalone: true,
  imports: [MatIconModule, HeadingSectionType01Component, FuseCardComponent, NgStyle, NgFor, CommonModule, CountersType01Component, ScrollerSectionType01Component, BannerSectionType01Component, ChangeGameType01Component],
  templateUrl: './corporate-travel-type02.component.html',
  styleUrl: './corporate-travel-type02.component.scss'
})
export class CorporateTravelType02Component {


  public view: any = {
    metaDataContent: ''
  };

  constructor(private _tfmService: TFMService, private _cd: ChangeDetectorRef) {
    
      this.view.features = [];
      this.view.features.push({ icon: "mat_solid:airplanemode_active", title: "Corporate Flights", text: "Competitive fares servicing all domestic, regional, and international locations" });
      this.view.features.push({ icon: "mat_solid:car_rental", title: "Car Hire", text: "Negotiated rates including super cover with reduced insurance excess" });
      this.view.features.push({ icon: "mat_solid:hotel", title: "Accommodation", text: "Complete solutions for corporate travel across global destinations" });
      this.view.features.push({ icon: "heroicons_outline:face-smile", title: "We Have You Covered", text: "Purchasing of travel insurance" });
      this.view.features.push({ icon: "mat_outline:price_change", title: "Foreign Exchange", text: "Hand delivered to your offices" });
      this.view.features.push({ icon: "mat_outline:support_agent", title: "No More Call Centres", text: "24/7/365 emergency and after-hours service" });

      // this.view.features.push({ icon: "heroicons_outline:building-office-2", title: "Business Travel", text: "Industry leading technology providing best end-to-end experience." });
      // this.view.features.push({ icon: "mat_solid:settings_remote", title: "Controls", text: "Corporate Travel Programs aligned with Company requirements." });
      // this.view.features.push({ icon: "mat_solid:fast_forward", title: "Fast Acting", text: "Fast identification of out of policy behaviour." });
      // this.view.features.push({ icon: "heroicons_outline:face-smile", title: "Client Experience", text: "From before time of travel requisition to well after purchase and travel." });
      // this.view.features.push({ icon: "mat_solid:personal_injury", title: "Duty of care", text: "Risk management, Automated travel advisories and Travel Alerts." });
      // this.view.features.push({ icon: "mat_solid:mobile_screen_share", title: "Time", text: "Better tracking of performance through email alerts, scheduled reporting and dynamic reporting." });
  }

  startSlideshow(): void {
    setInterval(() => {
      const nextIndex = (this.view.currentImageIndex + 1) % this.view.imageHrefs.length;
      const nextImage = this.view.imageHrefs[nextIndex];

      this.fadeToImage(nextImage);
      this.view.currentImageIndex = nextIndex;
    }, 5000);
  }

  fadeToImage(nextImage: string): void {
    const img = new Image();
    img.src = nextImage;

    img.onload = () => {
      if (this.view.activeLayer === 1) {
        this.view.imageLayer2 = nextImage;
        this.view.activeLayer = 2;
      } else {
        this.view.imageLayer1 = nextImage;
        this.view.activeLayer = 1;
      }
      this._cd.detectChanges();
    };
  }

  ngOnInit(): void {

    this._tfmService.getSite().then(res => {
      this.view.site = res;
      this._tfmService.log('Corporate Travel Site: ', this.view.site);

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
    });
  
    this.view.currentImageIndex = 0;
    this.view.activeLayer = 1;
    this.view.imageLayer1 = '';
    this.view.imageLayer2 = '';

    this._tfmService.getContentBySection('corporate-travel').then((res) => {
      this.view.page = res;
      const images = this.view.page?.content?.images;

      if (images && images.length > 0) {
        this.view.imageHrefs = images
          .map((img: any) => {
            const viewLink = img._links?.find((link: any) => link.rel === 'view');
            return viewLink?.href ?? null;
          })
          .filter((href: string | null) => href !== null);

        this.view.imageLayer1 = this.view.imageHrefs[0];
        this.startSlideshow();
      }
    });
  }

}


